import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=58775ef7"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=58775ef7&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58775ef7')) {
      api.createRecord('58775ef7', component.options)
    } else {
      api.reload('58775ef7', component.options)
    }
    module.hot.accept("./index copy.vue?vue&type=template&id=58775ef7", function () {
      api.rerender('58775ef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/userInfo/index copy.vue"
export default component.exports